import React from 'react';
import { BarStackHorizontal } from '@vx/shape';

import { StackChart } from './stackChart.component';
import { CHART_TYPES } from '../charts.constants';

import { useIntl } from 'gatsby-plugin-intl';
export const HorizontalStackChart = ({ width, height, config, tabs, parser, data } = {}) => {
  const intl = useIntl();
  data['title'] = intl.formatMessage({ id: data.title });
  
  data['data'] = data.data.map((item) => {
    if (item?.country) {
      item.country=intl.formatMessage({ id: item.country })
      return item;
    }
    return item;
  });
  return (
    <StackChart
      width={width}
      height={height}
      config={config}
      chartData={data}
      type={CHART_TYPES.HORIZONTAL}
      stackComponent={BarStackHorizontal}
      tabs={tabs}
      customParser={parser}
    />
  );
};